import { SB } from '@play-co/replicant';
import {
  PetAttribute,
  petAttributes,
  PetStatusEffect,
  petStatusEffects,
} from '../pet/pet.ruleset';

export const visitSession = SB.object({
  // name of player currently being visited
  name: SB.string(),

  // player's Line name
  lineName: SB.string().optional(),

  // Photo of player currently player being visited
  photo: SB.string(),

  // Avatar frame of player currently being visited
  frame: SB.string(),

  // Line profile Photo of player currently player being visited
  linePhoto: SB.string().optional(),

  // name of friend's pet
  petName: SB.string(),

  // Wheter the pet was revived this session.
  revivedPet: SB.boolean(),

  // id of player currently being visited
  friendId: SB.string(),

  // Number of care actions completed during the visit
  careActions: SB.number(),

  // Number of paid care actions completed during the visit
  paidCareActions: SB.number(),

  // Number of conversation dialogs started during the visit
  friendDialogs: SB.number(),

  // Number of gems granted by the friend's pet during the visit
  gemsReceived: SB.number(),

  // Number of coins spent during the visit
  coinsSpent: SB.number(),

  // Current evolution of the friend's pet
  currentEvolution: SB.object({
    species: SB.string(),
    stage: SB.string(),
    // TODO: Remove this.
    level: SB.number().optional(),
  }),

  // Answers to the friend's pet's conversation
  answers: SB.map(
    SB.object({
      key: SB.string().optional(),
      value: SB.string(),
    }),
  ),

  // Last known state of friend's pet
  unsyncedChanges: SB.object({
    attributes: SB.object(
      petAttributes.reduce(
        (acc, cur) => {
          acc[cur] = SB.number().optional();
          return acc;
        },
        {} as Record<PetAttribute, SB.NumberSchema & SB.Optional<number>>,
      ),
    ),
    statusEffects: SB.object(
      petStatusEffects.reduce(
        (acc, cur) => {
          acc[cur] = SB.boolean().optional();
          return acc;
        },
        {} as Record<PetStatusEffect, SB.BooleanSchema & SB.Optional<boolean>>,
      ),
    ),
  }),

  // The attribute debuff values to apply at visit end
  attributeDebuffs: SB.object({
    love: SB.number(),
    stomach: SB.number(),
  }),

  isKickedOut: SB.boolean().optional(),

  // Features active for this user.
  features: SB.map(SB.boolean()),
});

export const visitSchema = {
  visit: SB.object({
    // Track data about current visit session
    visitSession: visitSession.optional(),

    // Amount of gem grants received today.
    gemsGrantsToday: SB.number(),

    // Time of last gem grant.
    lastGemsGrantAt: SB.number(),

    // Time of last performed visit.
    lastVisitAt: SB.number(),

    // Name of last visitor used for the pet to notify you.
    lastVisitorName: SB.string().optional(),

    // Map of player ids to timestamps of their most recent visit
    recentVisitsFrom: SB.map(SB.number()),

    // Map of player ids to timestamps of most recent to
    recentVisitsTo: SB.map(SB.number()),

    // Map of player ids to visit counts
    counts: SB.object({
      // Has visited
      visitsTo: SB.map(SB.number()),
      // Has been visited
      visitsFrom: SB.map(SB.number()),
    }),

    // Keep track of gem grant timestamps
    gemGrants: SB.map(SB.number()),

    // Gems not yet granted to player.
    pendingGemsGrants: SB.number().default(0),

    // Revived friends.
    revivedFriends: SB.number().optional(),

    // Was revived by a friend.
    revivedBy: SB.string().optional(),
  }),
};
